// ─────────────────────────────────────────────────────────────
// LukaDuka - Offline Signed-Out Screen (ver1)
// Shown by Router when the app opens with no connection and NO login is
// stored on this phone (signed out, or browser data cleared).
//
// ver1 - 2 November 2026 (Offline Capture screen - Layer 2c):
//   - Decision I: without a stored login there is no way to know whose
//     account a capture belongs to, so no capture is offered. A clear,
//     kind message instead of an error, and a Try again button.
//
// Path: src/app/offline/OfflineSignedOutScreen.tsx
// ─────────────────────────────────────────────────────────────

interface OfflineSignedOutScreenProps {
  /** Re-runs start-up. Shows the sign-in screen once back online. */
  onTryAgain: () => void
}

// Brand accent (not theme-dependent), as TimelinePage.
const BRAND_ACCENT = '#C17D4A'

export function OfflineSignedOutScreen({ onTryAgain }: OfflineSignedOutScreenProps) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '32px 24px', textAlign: 'center',
      background: 'var(--ui-bg, #FAF7F2)',
      fontFamily: 'var(--ui-font-body, "Plus Jakarta Sans", sans-serif)',
      boxSizing: 'border-box',
    }}>
      <div style={{ fontSize: 40, marginBottom: 16 }}>📡</div>
      <h1 style={{
        fontSize: 20, fontWeight: 700, margin: '0 0 8px',
        color: 'var(--ui-text, #2C2825)',
      }}>
        You're offline
      </h1>
      <p style={{
        fontSize: 14, lineHeight: 1.5, margin: '0 0 24px', maxWidth: 320,
        color: 'var(--ui-text-muted, #8A8078)',
      }}>
        You'll need to be online to sign in. Your story will be right here
        when you are.
      </p>
      <button
        onClick={onTryAgain}
        style={{
          padding: '12px 28px', borderRadius: 12,
          border: `1px solid ${BRAND_ACCENT}40`,
          background: `${BRAND_ACCENT}14`,
          color: BRAND_ACCENT,
          fontSize: 15, fontWeight: 600, cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Try again
      </button>
    </div>
  )
}
